import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { MAP_ENTITY_TYPES } from "@app/util/map/consts";
import getUsedEntityTypes from "@app/util/map/getUsedEntityTypes";

interface SavedFilterVisibilityChange {
  hiddenEntities: EntityTypesSupportedByMapsPage[];
  visibleEntities: EntityTypesSupportedByMapsPage[];
}

// `hiddenEntities` is measured against what is on screen now, so it never names an entity type that
// was already hidden. A filter that narrows to none or to all of the types hides nothing, and then
// only replaces another filter's narrowing — with no filter selected, a manual Entity Visibility
// choice stands.
const getSavedFilterVisibilityChange = (
  filter: MapFilterModel,
  currentVisibleEntities: EntityTypesSupportedByMapsPage[],
  hasSavedFilterApplied: boolean
): SavedFilterVisibilityChange => {
  const usedEntityTypes = getUsedEntityTypes(filter);

  if (usedEntityTypes.length === 0 || usedEntityTypes.length === MAP_ENTITY_TYPES.length) {
    return {
      hiddenEntities: [],
      visibleEntities: hasSavedFilterApplied ? MAP_ENTITY_TYPES : currentVisibleEntities,
    };
  }

  return {
    hiddenEntities: currentVisibleEntities.filter(
      (entityType) => !usedEntityTypes.includes(entityType)
    ),
    visibleEntities: usedEntityTypes,
  };
};

export default getSavedFilterVisibilityChange;
